"use client"

import { ParkingMeter } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ParkingMeterIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ParkingMeterIcon = component(Icon)({ as: ParkingMeter })
